/* @flow */

import { getLocationType } from '../../../libs/netgemLibrary/v8/helpers/Item';
import { ItemLocationKind, type NETGEM_API_V8_FEED_ITEM } from '../../../libs/netgemLibrary/v8/types/FeedItem';

const isVodItem: (item: NETGEM_API_V8_FEED_ITEM) => boolean = (item) => {
  const {
    locType,
    selectedLocation: { id },
  } = item;

  const type = locType ?? getLocationType(id);
  return type === ItemLocationKind.EST || type === ItemLocationKind.SVOD || type === ItemLocationKind.TVOD || type === ItemLocationKind.VOD;
};

export { isVodItem };
